import {Controller} from "stimulus";

export default class extends Controller {
    static targets = ["sendToMyselfTab", "sendToOtherTab", "sendToMyselfContent", "sendToOtherContent" ];

    connect () {
        if (this.selectedTab == 'SEND_TO_OTHER') {
            this.showSendToOther();
        } else {
            this.showSendToMe();
        }
    }

    get selectedTab() {
        return this.data.get("selectedTab");
    }

    set selectedTab(tab) {
        this.data.set("selectedTab", tab);
        this.publishUpdateSendOptionEvent(tab);
    }

    showSendToMe () {
        this.selectedTab = 'SEND_TO_MYSELF';
        this.showTabAndContent(this.sendToMyselfTabTarget, this.sendToMyselfContentTarget);
        this.hideTabAndContent(this.sendToOtherTabTarget, this.sendToOtherContentTarget);
    }

    showSendToOther () {
        this.selectedTab = 'SEND_TO_OTHER';
        this.showTabAndContent(this.sendToOtherTabTarget, this.sendToOtherContentTarget);
        this.hideTabAndContent(this.sendToMyselfTabTarget, this.sendToMyselfContentTarget);
    }

    showTabAndContent(targetTab, targetTabContent) {
        this.toggleTabAndContent(targetTab, targetTabContent, true);
    }

    hideTabAndContent(targetTab, targetTabContent) {
        this.toggleTabAndContent(targetTab, targetTabContent, false);
    }

    toggleTabAndContent(targetTab, targetTabContent, showTab) {
        targetTab.classList.toggle("border-brand", showTab);
        targetTab.classList.toggle("font-bold", showTab);
        targetTabContent.classList.toggle("hidden", !showTab)
    }

    publishUpdateSendOptionEvent(option) {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent("send-option-update", true, true, null);
        event.sendOption = option;
        this.element.dispatchEvent(event);
    }
  }
  